import { ConeGeometry, Mesh, MeshLambertMaterial } from "three";
export class Cone extends Mesh {
    constructor(color, radius = 1, height = 1, z = 0, opacity = 1) {
        const geometry = new ConeGeometry(radius, height, 9, 1);
        const material = new MeshLambertMaterial({ color: color, transparent: opacity < 1, opacity });
        super(geometry, material);
        this.name = "Cone";
        this.position.z = z;
        this.interceptedByRaycaster = false;
    }
    dispose() {
        super.dispose();
        this.geometry.dispose();
        this.material.dispose();
    }
}
//# sourceMappingURL=Cone.js.map